/**
 * Which previews the signed-in person has been added to.
 *
 * Loaded once after sign-in (App.jsx). Admins get nothing automatically — a
 * preview is on only when an admin has added that person by name. Until the
 * answer arrives, and if it cannot be read, every preview is OFF, so the
 * existing version is always what people fall back to.
 */
import { create } from 'zustand';
import { fetchMyFeaturePreviews } from '@/api/endpoints/featurePreviews.js';

export const useFeaturePreviewStore = create((set, get) => ({
  enabled: [],
  loaded: false,
  async load(force = false) {
    if (get().loaded && !force) return;
    try {
      const res = await fetchMyFeaturePreviews();
      set({ enabled: Array.isArray(res?.enabled) ? res.enabled : [], loaded: true });
    } catch {
      set({ enabled: [], loaded: true });
    }
  }
}));

/** True when the signed-in person is on this preview's list. */
export function useFeaturePreview(featureId) {
  return useFeaturePreviewStore((s) => s.enabled.includes(featureId));
}
